import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from '@angular/forms';

import { ContactRequestService } from './services/contactRequestService';
import { Wizard } from './wizards/wizard.component';
import { WizardProgress } from "./wizards/wizard-progress.component";
import { WizardProgressService } from "./services/wizardProgressService";
import { WizardComplete } from "./wizards/wizard-complete.component";

@NgModule({
    declarations: [
        AppComponent,
        Wizard,
        WizardProgress,
        WizardComplete
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule
    ],
    providers: [ContactRequestService, WizardProgressService],
    bootstrap: [AppComponent, WizardProgress]
})
export class AppModule { }
